<template>
  <div>
    <div
      v-if="loading"
      class="text-center"
      :style="styleObject"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando Dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <div>
      <canvas
        id="myChart6"
        width="20"
        height="20"
      />
      <div v-if="valorExibicao">
        <span
          id="valorExibicao"
          :style="styleObjectvalorRestante"
        >
          {{ valorExibicao }}
        </span>
        <span v-if="valorRestante">
          <span
            id="valorRestanteExibicao"
            :style="styleObjectvalorRestante"
          >
            {{ valorRestante }}
          </span>
          <span id="spanValorRestanteExibicao">
            *Até hoje
          </span>
        </span>
      </div>
      <div v-else>
        <span v-if="valorRestante">
          <span
            id="valorRestante"
            :style="styleObjectvalorRestante"
          >
            {{ valorRestante }}
          </span>
          <span id="spanValorRestante">
            *Até hoje
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import Comercial from '../../../../services/comercial'
  import ChartDataLabels from 'chartjs-plugin-datalabels'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashboardChartLineBar',
    components: {
    },

    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      colors: [],
      myChart: {},
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      supervisor: [],
      receita: [],
      vendedor: [],
      rede: [],
      categoria: [],
      promotor: [],
      valorRestante: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      styleObjectvalorRestante: {
        color: '#ed934f',
      },
      valorExibicao: false,
      montarGrafico: true,
      loading: false,
      error: null,
    }),

    created () {
      eventEmit.$on('update-datas', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-datas', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, supervisor, receita, vendedor, rede, categoria, promotor) {
        this.primeiroDia = primeiroDia
        this.dataFinal = dataFinal
        this.select = select
        this.supervisor = supervisor
        this.receita = receita
        this.vendedor = vendedor
        this.rede = rede
        this.categoria = categoria
        this.promotor = promotor

        this.valorRestante = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

        this.atualizaGrafico()
      },

      async atualizaGrafico () {
        this.loading = true

        if (this.myChart.data) {
          this.myChart.destroy()
        }

        await Comercial.showDadosGraficoBarrasValorMonetarioMetaDiario(this.primeiroDia, this.dataFinal, this.select, this.supervisor, this.receita, localStorage.tokencontrato, this.vendedor, this.rede, this.categoria, this.promotor, [], []).then(resposta => {
          if (resposta.data.status) {
            this.valorRestante = resposta.data.valorRestante.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            const ctx = document.getElementById('myChart6').getContext('2d')

            this.myChart = new Chart(ctx, {
              plugins: [ChartDataLabels],
              type: 'bar',
              data: {
                labels: ['Mês até hoje'],
                datasets: [
                  {
                    label: 'Fatura',
                    data: [resposta.data.valorFaturamento],
                    backgroundColor: '#4780b8',
                    order: 1,
                  },
                  {
                    label: 'Meta',
                    data: [resposta.data.valorMeta],
                    backgroundColor: '#cadaed',
                    order: 2,
                  },
                ],
              },
              options: {
                plugins: {
                  datalabels: {
                    display: true,
                    color: function (context) {
                      if (context.dataset.label === 'Fatura') {
                        return '#ed934f'
                      } else {
                        return 'transparent'
                      }
                    },
                    font: {
                      size: 11,
                    },
                    formatter: (value) => {
                      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                  },
                },
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                  }],
                  yAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                low: 10,
                high: 5,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    mode: 'label',
                    label: (tooltipItem, data) => {
                      var type = data.datasets[tooltipItem.datasetIndex].label
                      var valor = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

                      return type + ': ' + valor
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        tooltipItem[0].xLabel = 'Faturamento até momento'

                        return tooltipItem[0].xLabel
                      } else if (tooltipItem[0].datasetIndex === 1) {
                        tooltipItem[0].xLabel = 'O que falta'

                        return tooltipItem[0].xLabel
                      }
                    },
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.valorExibicao = false
            this.valorRestante = resposta.data.valorRestante.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.showSnackbar('error', 3000, 'Indicador "Quanto falta para atingirmos". Não há faturamento no mês corrente')
          } else if (resposta.data.text === 'Não há meta no período selecionado') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.valorRestante = resposta.data.valorRestante.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.valorExibicao = false
            this.showSnackbar('error', 3000, 'Indicador "Quanto falta para atingirmos". Não há meta no mês corrente')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  @media only screen
  and (min-device-width : 320px)
  and (max-device-width : 480px) {
    #valorRestante {
      font-size: 12px;
    }
  }
</style>

<style lang="sass">
  #valorRestante
    font-size: 20px
    display: grid
    align-items: center
    font-weight: bold

  #spanValorRestante
    font-size: 10px
    display: grid
    align-items: center

  #valorRestanteExibicao
    font-size: 20px
    display: grid
    align-items: center
    font-weight: bold
    margin-top: 6rem

  #valorExibicao
    font-size: 14px
    display: grid
    align-items: center
    font-weight: bold
    margin-top: -8rem

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
</style>
